require('./locations-map/locations-map.scss');
require('../../vendor/leaflet/L.TileLayer.NoGap.js');
require('../../vendor/leaflet/MarkerCluster.css');
require('../../vendor/leaflet/MarkerCluster.default.css');
require('../../vendor/leaflet/leaflet.markercluster.js');
var BaseViews = require('./base');
var FeaturePopupContent = require('./locations-map/feature-popup-content.js');
var CartLocationDisplay = require('./cart/cart-location-display');

var LocationsMap = BaseViews.LayoutView.extend({
    map: null,
    template: require('./locations-map/locations-map.html'),
    className: 'fmcy-locations-map',
    ui: {
        mapTarget: '.fmcy-locations-map-target',
        closeMapButton: '.fmcy-locations-map-close-btn'
    },
    triggers: {
      'click @ui.closeMapButton': 'close:clicked'
    },
    initialize: function(options) {
        var self = this;
        this.options = _.defaults(
            options || {},
            {
                _appChannel: null,
                allLocations: true,
                adjustForMenuBar: true,
                showCloseButton: true,
                showZoomControls: true,
                scrollWheelZoom: true,
                animate: true,
                topPos: null,
                botPos: 0,
                leftPos: 0
            }
        );
    },
    tweenOnPopUpOpen: true,
    _initializeMap: function() {
      var self = this;

      this.map = L.map(this.ui.mapTarget[0], {
        renderer: L.canvas(),
        maxZoom: 18,
        zoomControl: this.options.showZoomControls,
        scrollWheelZoom: this.options.scrollWheelZoom
      });

      if (this.map) {
          this.map._onResize();
      }

      this._onWindowResize();

      this.map.createPane('basemap');

      // set map to Victoria...
      this.map.setView([48.4284, -123.3656], 10);
      var basemap = L.tileLayer('https://api.mapbox.com/styles/v1/ogfarm/ckq9yvych0wi418mp23gspn8r/tiles/256/{z}/{x}/{y}?access_token=pk.eyJ1Ijoib2dmYXJtIiwiYSI6ImNrcTcyOW5jdjAwamsydXBnOHB1eTU0bG0ifQ.gJU9G9adyvvv8X4UBdUGhw').addTo(this.map);

      this.map.dragging.enable();

      if (this.map.tap) {
          this.map.tap.enable();
      }

      this.map.touchZoom.enable();
      this.map.doubleClickZoom.enable();

      $(window).on('resize.' + this.cid, _.bind(this._onWindowResize, this));


      this.map.on('popupopen', function(e) {
        _.delay(function () {
          var px = self.map.project(e.popup._latlng); // find the pixel location on the map where the popup anchor is
          px.y -= (e.popup._container.clientHeight/2) - 90;
          if (self.tweenOnPopUpOpen == true) {
            self.map.panTo(self.map.unproject(px),{animate: true}); // pan to new center
          }
        }, 250);
      });

      this.map.on('zoomstart', function (e) {
        self._removeFeaturePopup();
      });

    },
    _displayFarmacyLocations: function () {
      var self = this;
      this.markerClusterGroup = L.markerClusterGroup();

      var farmacyMarkerIcon = L.divIcon({
          className: 'map-marker-farmacy',
          iconSize: [50, 50],
          iconAnchor: [25, 50],
          popupAnchor: [-3, -76]
      });

      this._locations = this.options._appChannel.request('get:locations');
      this._locationsTurfPointsArray = [];
      this._locations.each(function (model) {
        var farmacyMarker = L.marker([model.get('lat'), model.get('lng')], {icon: farmacyMarkerIcon});
        farmacyMarker.bindTooltip('<div class="map-marker-farmacy-tooltip"><div class="map-marker-farmacy-tooltip-title">' + model.get('name') + '</div><div class="map-marker-farmacy-tooltip-subtitle">' + model.get('line_1') + '</div></div>', { permanent: true, offset: [0, 0], direction: 'bottom'});
        farmacyMarker.on('click', function () {
          self._displayFeaturePopUp({
            lat: model.get('lat'),
            lon: model.get('lng'),
            title: null,
            description: null,
            imageUrl: model.get('image_medium_url'),
            model: model
          });

        });

        self.markerClusterGroup.addLayer(farmacyMarker);

        model.set('feature', farmacyMarker);
        self._locationsTurfPointsArray.push(turf.point([model.get('lng'), model.get('lat')]));
      });

      this.map.addLayer(this.markerClusterGroup);
      _.delay(function () {
        self._zoomToFeatures(self._locationsTurfPointsArray);
      }, 500);
    },

    _displayPickupLocation: function () {
      this._location = this.options._appChannel.request('get:filter:location:details');
      var self = this;
      this.markerClusterGroup = L.markerClusterGroup();

      var farmacyMarkerIcon = L.divIcon({
          className: 'map-marker-farmacy',
          iconSize: [50, 50],
          iconAnchor: [25, 50],
          popupAnchor: [-3, -76]
      });

      this._locationsTurfPointsArray = [];

      this.map.setView([this._location.get('lat'), this._location.get('lng')], 16);

      var farmacyMarker = L.marker([this._location.get('lat'), this._location.get('lng')], {icon: farmacyMarkerIcon});

      this.markerClusterGroup.addLayer(farmacyMarker);

      this._location.set('feature', farmacyMarker);
      this._locationsTurfPointsArray.push(turf.point([this._location.get('lng'), this._location.get('lat')]));

      // offset...
      var px = this.map.project([this._location.get('lat'), this._location.get('lng')]); // find the pixel location on the map where the popup anchor is
      px.x += 150;
      var popupOffsetLocation = this.map.unproject(px);
      this._locationsTurfPointsArray.push(turf.point([popupOffsetLocation.lng, popupOffsetLocation.lat]));
      // end offset

      this.map.addLayer(this.markerClusterGroup);

      var _cartLocationDisplay = new CartLocationDisplay({
        _appChannel: this.options._appChannel,
        alignment: 'vertical'
      });

      this._zoomToFeatures(self._locationsTurfPointsArray, function () {
        self._displayFeaturePopUp({
          lat: self._location.get('lat'),
          lon: self._location.get('lng'),
          title: null,
          description: null,
          contentView: _cartLocationDisplay,
          model: self._location,
          tweenToExtent: false
        });
      }, 0, 20);

    },
    displayDeliveryLocation: function (deliveryLocation) {
      var self = this;
      var userMarkerIcon = L.divIcon({
          className: 'map-marker-farmacy-delivery-location',
          iconSize: [50, 50],
          iconAnchor: [25, 50],
          popupAnchor: [-3, -76]
      });
      self._locationsTurfPointsArray = [];
      if (self.deliverLocationMarker != undefined) {
            this.map.removeLayer(self.deliverLocationMarker);
       };
      self.deliverLocationMarker = L.marker([deliveryLocation.latLng[0], deliveryLocation.latLng[1]], {icon: userMarkerIcon}).addTo(self.map);

      var px = this.map.project([deliveryLocation.latLng[0], deliveryLocation.latLng[1]]); // find the pixel location on the map where the popup anchor is
      px.x += 450;
      var popupOffsetLocation = self.map.unproject(px);
      self._locationsTurfPointsArray.push(turf.point([popupOffsetLocation.lng, popupOffsetLocation.lat]));

      self._locationsTurfPointsArray.push(turf.point([deliveryLocation.latLng[1], deliveryLocation.latLng[0]]));

      self._zoomToFeatures(self._locationsTurfPointsArray, function () {
        // zoomed
      }, 0, 20);
    },
    _findClosestLocationToUser: function (lat, lon) {
      var self = this;
      var userfrom = turf.point([lon, lat]);
      var closestDistance = 1000000;
      this.closestLocationModel = null;

      this._locations.each(function (model) {
        var to = turf.point([model.get('lng'), model.get('lat')])
        var distance = turf.distance(userfrom, to);
        if (distance < closestDistance) {
          closestDistance = distance;
          self.closestLocationModel = model;
        }
      });

      this._locations.each(function (model) {
        if (self.closestLocationModel !== model) {
          self.map.removeLayer(model.get('feature'));
        }
      });

      this.trigger('map:closest:point:user:detected', self.closestLocationModel, closestDistance);

      var closestLocationTurfPoint = turf.point([self.closestLocationModel.get('lng'), self.closestLocationModel.get('lat')]);
      var pointA = new L.LatLng(lat, lon);
      var pointB = new L.LatLng(self.closestLocationModel.get('lat'), self.closestLocationModel.get('lng'));

      this._zoomToFeatures([userfrom, closestLocationTurfPoint], function () {
        var pointList = [pointA, pointB];

        self.lineBetweenUserAndLocation = new L.Polyline(pointList, {
            color: 'red',
            weight: 3,
            opacity: 0.5,
            smoothFactor: 1,
            dashArray: '1,7'
        });

        self.lineBetweenUserAndLocation.addTo(self.map);

        _.delay(function () {
          self._cleanupUserPointLocation();
          self._zoomToFeatures([closestLocationTurfPoint], function () {
            self._displayFeaturePopUp({
              lat: self.closestLocationModel.get('lat'),
              lon: self.closestLocationModel.get('lng'),
              title: null,
              description: null,
              model: self.closestLocationModel
            });
          });
        }, 3000);
      });
    },
    _cleanupUserPointLocation: function() {
      this.map.removeLayer(this.lineBetweenUserAndLocation);
      this.map.removeLayer(this.userMarker);
    },
    _displayFeaturePopUp: function (options) {
        var options = _.defaults(
            options || {},
            {
                lat: 0,
                lon: 0,
                title: 'testing',
                description: null,
                model: options.model,
                contentView: null,
                imageUrl: null,
                tweenToExtent: true
            }
        );

        if (options.tweenToExtent && this.options.animate) {
          this.tweenOnPopUpOpen = true;
        } else {
          this.tweenOnPopUpOpen = false;
        }

        var self = this;
        var popupLocation = [];

        popupLocation[0] = options.lat;
        popupLocation[1] = options.lon;

        var px = this.map.project([popupLocation[0], popupLocation[1]]); // find the pixel location on the map where the popup anchor is
        px.y -= 50; // this should be based on icon size...
        var popupOffsetLocation = this.map.unproject(px);
        popupLocation[0] = popupOffsetLocation.lat;
        popupLocation[1] = popupOffsetLocation.lng;

        var view = new FeaturePopupContent({
            title: options.title,
            description: options.description,
            childView: options.contentView,
            featureImageUrl: options.imageUrl,
            temp_closed: options.model.get('temp_closed'),
            temp_closed_message: options.model.get('temp_closed_message')
        });

        view.on('feature:selected', function () {
          self.trigger('map:feature:selected', options.model);
        });

        this.popup = L.popup({
            minWidth: 180,
            autoPan: false
        }).setLatLng([popupLocation[0], popupLocation[1]])
            .setContent(view.render().el)
            .openOn(self.map);
    },
    _removeFeaturePopup: function () {
      if (this.popup) {
        this.map.removeLayer(this.popup);
      }
    },
    _getPaddingBasedOnScreenSize: function () {
      var padding = 200;
      var windowWidth = $(window).width();
      if (windowWidth <= 650) {
        padding = 150;
      }
      if (windowWidth <= 411) {
        padding = 100;
      }
      if (windowWidth <= 375) {
        padding = 60;
      }
      if (windowWidth <= 320) {
        padding = 10;
      }
      return padding;
    },
    _zoomToFeatures: function (featuresArray, callBack, delay, padding) {
        var self = this;
        if (!padding) {
          padding = this._getPaddingBasedOnScreenSize();
        }
        if (!delay) {
          delay = 2000;
        }

        if (!self.options.animate) {
          delay = 0;
        }

        // check if a singular feature object is being passed in...
        if (!$.isArray(featuresArray)) {
          var featureObject = featuresArray;
          featuresArray = [featureObject];
        }
        if (featuresArray.length == 0) {
          return;
        }
        // Zoom to bounds of features...
        var features = turf.featureCollection(featuresArray);
        var bbox = turf.bbox(features);
        var bboxPolygon = turf.bboxPolygon(bbox);
        var boundsArray = [[
            bbox[1], bbox[0]
        ], [
            bbox[3], bbox[2]
        ]];

        var hasMapCenter = true;
        try {
            this.map.getCenter()
        }
        catch(err) {
            hasMapCenter = false;
        }

        if (hasMapCenter && self.options.animate) {
          if (featuresArray.length === 1) {
            this.map.flyToBounds(boundsArray, {
                animate: self.options.animate,
                padding: [padding, padding],
                maxZoom: 12
            });
          } else {
            this.map.flyToBounds(boundsArray, {
                animate: self.options.animate,
                padding: [padding, padding]
            });
          }
        } else {
          this.map.fitBounds(boundsArray, {
              animate: self.options.animate,
              padding: [padding, padding]
          });
        }

        if (callBack) {
          _.delay(function () {
            callBack();
          }, delay);
        }
    },
    mapToFeaturesExtent: function () {
      var self = this;
      if (this._locationsTurfPointsArray) {
        var features = turf.featureCollection(self._locationsTurfPointsArray);
        var bbox = turf.bbox(features);
        var bboxPolygon = turf.bboxPolygon(bbox);
        var boundsArray = [[
            bbox[1], bbox[0]
        ], [
            bbox[3], bbox[2]
        ]];

        var padding = this._getPaddingBasedOnScreenSize();

        _.delay(function () {
          self.map.fitBounds(boundsArray, {
              animate: false,
              padding: [padding, padding]
          });
        }, 50);
      }
    },
    addUserLocationToMap: function (location) {
      var self = this;
      var userMarkerIcon = L.divIcon({
          className: 'map-marker-farmacy-user-location',
          iconSize: [50, 50],
          iconAnchor: [25, 50],
          popupAnchor: [-3, -76]
      });
      self.userMarker = L.marker([location.coords.latitude, location.coords.longitude], {icon: userMarkerIcon}).addTo(self.map);

      self._locations.each(function (model) {
        self._locationsTurfPointsArray.push(turf.point([model.get('lng'), model.get('lat')]));
      });

      self._locationsTurfPointsArray.push(turf.point([location.coords.longitude, location.coords.latitude]));

      self._findClosestLocationToUser(location.coords.latitude, location.coords.longitude);

    },
    _onWindowResize: function (event) {
      var topPos = 81;
      var leftPos = 0;
      var botPos = 0;
      if (this.options.adjustForMenuBar == false) {
        topPos = 0;
      }

      if (this.options.topPos) {
        topPos = this.options.topPos;
      }

      if (this.options.leftPos) {
        leftPos = this.options.leftPos;
      }

      if (this.options.botPos) {
        botPos = this.options.botPos;
      }

      this.ui.mapTarget.css('top', topPos);
      this.ui.mapTarget.css('left', leftPos);
      this.ui.mapTarget.height($(window).height() - topPos - botPos);
      this.ui.mapTarget.width($(window).width() - leftPos);
      if (this.map) {
          this.map._onResize();
      }
    },
    adjustMapContainerPosition(topPos,leftPos) {
      if (leftPos !== null) {
        this.options.leftPos = leftPos;
      }
      if (topPos !== null) {
        this.options.topPos = topPos;
      }
      this._onWindowResize();
    },
    onShow: function() {
        var self = this;
        this._initializeMap();
        if (this.options.allLocations == true) {
          this._displayFarmacyLocations();
        } else {
          this._displayPickupLocation();
        }
    },
    onRender: function () {
      var self = this;
      if (this.options.showCloseButton == false) {
        this.ui.closeMapButton.hide();
      }
      this.options._appChannel.on('map:display:delivery:location', function (deliveryLocation) {
        self.displayDeliveryLocation(deliveryLocation);
      });
      BaseViews.LayoutView.prototype.onRender.call(this);
    },
    onDestroy: function () {
      this.options._appChannel.off('map:display:delivery:location');
      $(window).off('resize.' + this.cid);
    }
});

module.exports = LocationsMap;



/** WEBPACK FOOTER **
 ** ./assets/js/common/locations-map.js
 **/